<template>
  <div>
    <span v-if="this.$route.query.flag == 'view'">
      <BasicViewInfo ref="getBasicView" @childClick="childClick">></BasicViewInfo>
    </span>
    <span v-else>
      <BasicUpdateInfo ref="getBasicUpdate" @childClick="childClick"></BasicUpdateInfo>
    </span>
  </div>

</template>

<script>

  import BasicViewInfo from "../../../components/member/BasicViewInfo";
  import BasicUpdateInfo from "../../../components/member/BasicUpdateInfo";
  export default {
    name: "BasicInfo",
    components: {BasicUpdateInfo, BasicViewInfo},
    data() {
      return {}
    },
    mounted() {


    },
    methods: {
      childClick(e) {
        this.$emit('childClick', e)
      },
      commitEimsUserBasic() {
        this.$refs.getBasicUpdate.commitEimsUserBasic();
      },
      validateFileForm() {
        if (this.$route.query.flag == "view") {
          return this.$refs.getBasicView.validateFileForm();
        } else {
          return this.$refs.getBasicUpdate.validateFileForm();
        }
      },
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/member/memberInfo/BasicInfo.vue